import './Organizer.scss';

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.193l-1.87 8.81c-.138.625-.5.778-1.012.484l-2.79-2.06-1.348 1.295c-.156.156-.287.287-.59.287l.21-2.98 5.16-4.66c.225-.2-.05-.31-.35-.11l-6.37 4.01-2.75-.86c-.6-.19-.61-.6.12-.89l10.72-4.13c.5-.18.94.11.77.69z"/>
  </svg>
);

const Organizer = () => {
  const telegramUsername = 'muzafarova_wedding';
  const organizerName = 'Софья';
  const photoUrl = '/organizatorPhoto.png';

  return (
    <section className="organizer">
      <h2 className="organizer__title">Детали</h2>
       <p className="organizer__description">
          Дорогие гости, если вы подготовили для нас творческий подарок или у <br/> вас есть вопросы касаемо нашего
          мероприятия, вы всегда можете обратиться к нашему организатору Софье.
       </p>

       <div className="organizer__card">
          <div className="organizer__photo-container">
             <img
                className="organizer__photo"
                src={photoUrl}
                alt={organizerName}
                onError={(e) => {
                   e.target.style.display = 'none';
                }}
             />
          </div>

          <a
             className="organizer__button"
             href={`https://t.me/${telegramUsername}`}
             target="_blank"
             rel="noopener noreferrer"
          >
             <TelegramIcon/>
             Написать в Telegram
          </a>

          <p className="organizer__role">@muzafarova_wedding</p>

       </div>
    </section>
  );
};

export default Organizer;
